import { IConfig } from '@types'

const config: IConfig = {
    networks: {
        polygon: {
            livenet: {
                name: 'mainnet',
                chain_id: 0x89,
                api_key: 'U_B6fIsFJOWFWQ7l8C9c_8i4jADkX4u6',
                currency: 'MATIC',
                consensus: 'pos',
                explorer_address: 'https://polygonscan.com/address/',
                explorer_transaction: 'https://polygonscan.com/tx/',
                gas_tracker_url:
                    'https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=7P39I4ZFQTWC8B7MQ6IR6AWS53YWIHYSE1',
                nft_tracker_url: 'https://polygon-mainnet.g.alchemy.com/nft/v2/U_B6fIsFJOWFWQ7l8C9c_8i4jADkX4u6',
                provider_param: {
                    url: 'https://polygon-mainnet.g.alchemy.com/v2/U_B6fIsFJOWFWQ7l8C9c_8i4jADkX4u6',
                    rpc: {
                        1: 'https://polygon-mainnet.g.alchemy.com/v2/U_B6fIsFJOWFWQ7l8C9c_8i4jADkX4u6',
                    },
                },
            },
            testnet: {
                name: 'mumbai',
                chain_id: 0x13881,
                api_key: 'oUfRdSWdOOmvqvChYKged2TwtupKxkLF',
                currency: 'MATIC',
                consensus: 'pos',
                explorer_address: 'https://mumbai.polygonscan.com/address/',
                explorer_transaction: 'https://mumbai.polygonscan.com/tx/',
                gas_tracker_url:
                    'https://api-mumbai.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=7P39I4ZFQTWC8B7MQ6IR6AWS53YWIHYSE1',
                nft_tracker_url: 'https://polygon-mumbai.g.alchemy.com/nft/v2/oUfRdSWdOOmvqvChYKged2TwtupKxkLF',
                provider_param: {
                    url: 'https://polygon-mumbai.g.alchemy.com/v2/oUfRdSWdOOmvqvChYKged2TwtupKxkLF',
                    rpc: {
                        3: 'https://polygon-mumbai.g.alchemy.com/v2/oUfRdSWdOOmvqvChYKged2TwtupKxkLF',
                    },
                },
            },
        },
        ethereum: {
            livenet: {
                name: 'mainnet',
                chain_id: 0x01,
                api_key: 'LlFBdDwUNKWenZ6fe0H4WbsJH5q14u7O',
                currency: 'ETH',
                consensus: 'pow',
                explorer_address: 'https://etherscan.io/address/',
                explorer_transaction: 'https://etherscan.io/tx/',
                gas_tracker_url:
                    'https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=36XTKGWV92Q7B9FEKMRJRXQH5UBG3C2ANE',
                nft_tracker_url: 'https://eth-mainnet.g.alchemy.com/nft/v2/LlFBdDwUNKWenZ6fe0H4WbsJH5q14u7O',
                provider_param: {
                    url: 'https://eth-mainnet.g.alchemy.com/v2/LlFBdDwUNKWenZ6fe0H4WbsJH5q14u7O',
                    rpc: {
                        1: 'https://eth-mainnet.g.alchemy.com/v2/LlFBdDwUNKWenZ6fe0H4WbsJH5q14u7O',
                    },
                },
            },
            testnet: {
                name: 'goerli',
                chain_id: 0x05,
                api_key: 'Ahe4hhsbKihUBCoOnLHQQgnKlnxfwfay',
                currency: 'ETH',
                consensus: 'pow',
                explorer_address: 'https://goerli.etherscan.io/address/',
                explorer_transaction: 'https://goerli.etherscan.io/tx/',
                nft_tracker_url: 'https://eth-goerli.g.alchemy.com/nft/v2/Ahe4hhsbKihUBCoOnLHQQgnKlnxfwfay',
                gas_tracker_url:
                    'https://api-goerli.etherscan.io/api?module=gastracker&action=gasoracle&apikey=NXIMNR3HSJR58AHXU4TE6Y7ZD73BIHE3MR',
                provider_param: {
                    url: 'https://eth-goerli.g.alchemy.com/v2/Ahe4hhsbKihUBCoOnLHQQgnKlnxfwfay',
                    rpc: {
                        5: 'https://eth-goerli.g.alchemy.com/v2/Ahe4hhsbKihUBCoOnLHQQgnKlnxfwfay',
                    },
                },
            },
            rinkeby: {
                name: 'rinkeby',
                chain_id: 0x04,
                api_key: 'QGU-P5kxN_AWyKWsd8q1UVAj6wS9AdB3',
                currency: 'ETH',
                consensus: 'pow',
                explorer_address: 'https://rinkeby.etherscan.io/address/',
                explorer_transaction: 'https://rinkeby.etherscan.io/tx/',
                gas_tracker_url:
                    'https://api-rinkeby.etherscan.io/api?module=gastracker&action=gasoracle&apikey=NXIMNR3HSJR58AHXU4TE6Y7ZD73BIHE3MR',
                nft_tracker_url: 'https://eth-rinkeby.g.alchemy.com/nft/v2/QGU-P5kxN_AWyKWsd8q1UVAj6wS9AdB3',
                provider_param: {
                    url: 'https://eth-rinkeby.alchemyapi.io/v2/QGU-P5kxN_AWyKWsd8q1UVAj6wS9AdB3',
                    rpc: {
                        4: 'https://eth-rinkeby.alchemyapi.io/v2/QGU-P5kxN_AWyKWsd8q1UVAj6wS9AdB3',
                    },
                },
            },
        },
        algorand: {
            livenet: {
                name: 'mainnet',
                chain_id: 0x01,
                currency: 'ALGO',
                consensus: 'pos',
                explorer_address: 'https://goalseeker.purestake.io/algorand/mainnet/application/',
                explorer_transaction: 'https://goalseeker.purestake.io/algorand/mainnet/application/',
                gas_tracker_url:
                    'https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=36XTKGWV92Q7B9FEKMRJRXQH5UBG3C2ANE',
                nft_tracker_url:
                    'https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=36XTKGWV92Q7B9FEKMRJRXQH5UBG3C2ANE',
                provider_param: {
                    token: {
                        'X-API-Key': 'G3J94uGQtB5rCOGTjTcmY3x8TIGC0lqH3GZtvEZl', // 'YOUR PURESTAKE API KEY HERE'
                    },
                    url: 'https://mainnet-algorand.api.purestake.io/ps2',
                    port: '',
                },
            },
            testnet: {
                name: 'testnet',
                chain_id: 0x04,
                currency: 'ALGO',
                consensus: 'pos',
                explorer_address: 'https://goalseeker.purestake.io/algorand/testnet/application/',
                explorer_transaction: 'https://goalseeker.purestake.io/algorand/mainnet/application/',
                gas_tracker_url:
                    'https://api-rinkeby.etherscan.io/api?module=gastracker&action=gasoracle&apikey=NXIMNR3HSJR58AHXU4TE6Y7ZD73BIHE3MR',
                nft_tracker_url:
                    'https://api-rinkeby.etherscan.io/api?module=gastracker&action=gasoracle&apikey=NXIMNR3HSJR58AHXU4TE6Y7ZD73BIHE3MR',
                provider_param: {
                    token: {
                        'X-API-Key': 'G3J94uGQtB5rCOGTjTcmY3x8TIGC0lqH3GZtvEZl', // 'YOUR PURESTAKE API KEY HERE'
                    },
                    url: 'https://testnet-algorand.api.purestake.io/ps2',
                    port: '',
                },
            },
        },
    },
    general: {
        appName: 'Faktura',
        appLogoUrl: 'faktura.art',
        bugsnag: 'd707afca58cf2e33ceec296598de7d18',
    },
    wallets: [
        { name: 'algosigner', support: ['web'], type: 'crypto' },
        { name: 'metamask', support: ['web'], type: 'crypto' },
        { name: 'walletconnect', support: ['web', 'mobile'], type: 'crypto' },
        { name: 'coinbase', support: ['web', 'mobile'], type: 'crypto' },
        { name: 'crossmint', support: ['web', 'mobile'], type: 'creditcard' },
        { name: 'winter', support: ['web', 'mobile'], type: 'creditcard' },
        { name: 'wert', support: ['web', 'mobile'], type: 'creditcard' },
    ],
}

export default config
